/* import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import { useLocalStorage } from '@/utils/useLocalStorage' */
import { ReactNode } from 'react'

export const PrivateRoute = ({ children }: { children: ReactNode }) => {
  // const [jwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')

  return children
}
